import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragIndicator from "@mui/icons-material/DragIndicator";

/**
 * One table row with a drag handle in the first cell. Pass remaining cells as children (without the handle column).
 */
export default function SubmissionSortableTableRow({
  id,
  disabled,
  children,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: String(id), disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.92 : 1,
    zIndex: isDragging ? 2 : undefined,
    position: "relative",
  };

  return (
    <tr ref={setNodeRef} style={style} className="blog-row">
      <td
        style={{
          width: 44,
          textAlign: "center",
          verticalAlign: "middle",
          padding: "12px 6px",
        }}
      >
        <button
          type="button"
          aria-label="Drag to reorder"
          disabled={disabled}
          {...attributes}
          {...listeners}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            border: "none",
            borderRadius: 6,
            background: disabled ? "#f3f4f6" : "#eef2ff",
            color: disabled ? "#9ca3af" : "#4f46e5",
            cursor: disabled ? "not-allowed" : "grab",
          }}
        >
          <DragIndicator style={{ fontSize: 20 }} />
        </button>
      </td>
      {children}
    </tr>
  );
}
